var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.943,
    height: 18,
    viewBox: "0 0 21.943 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(0 -45.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M163.586,166H151.929A1.931,1.931,0,0,0,150,167.928v6.429a1.931,1.931,0,0,0,1.929,1.929h10.105l2.383,2.383a.643.643,0,0,0,1.1-.454V167.928A1.931,1.931,0,0,0,163.586,166Zm-3.214,7.071h-5.229a.643.643,0,1,1,0-1.286h5.229a.643.643,0,1,1,0,1.286Zm1.286-2.571h-7.8a.643.643,0,1,1,0-1.286h7.8a.643.643,0,0,1,0,1.286Z",
    transform: "translate(-143.571 -114.857)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M.4,58.807a.643.643,0,0,0,.7-.139L3.48,56.285H5.143V53.07a3.218,3.218,0,0,1,3.214-3.214h7.157V47.928A1.929,1.929,0,0,0,13.586,46H1.929A1.929,1.929,0,0,0,0,47.928V58.213a.642.642,0,0,0,.4.594Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.8992ce0e137b8b68031cefd7f633a98e.svg";
export { ForwardRef as ReactComponent };